import RidersEyeSurgeryStep from "components/steps/RidersEyeSurgeryStep";

const Step15Page = () => <RidersEyeSurgeryStep />;

export default Step15Page;
